(ns common.schema.entities.lp-portal.lp-promotion
  (:require
   [common.schema.schema-utils :as su]
   [common.country :as country]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def schema
  (concat
   (su/text-simple-field :lp-promotion/title
                         "Title"
                         (system-controlled {:authorization su/access-system-lpg}))
   (su/text-simple-field :lp-promotion/description
                         "Description"
                         (system-controlled {:authorization su/access-system-lpg}))
   (su/url-field :lp-promotion/cover-image-url
                 "Cover image URL"
                 (system-controlled {:authorization su/access-system-lpg}))
   (su/url-field :lp-promotion/content-url
                 "Content URL"
                 (system-controlled {:authorization su/access-system-lpg}))
   (su/keyword-multi-field :lp-promotion/target-countries
                           "Target countries"
                           country/options
                           (system-controlled {:authorization su/access-system-lpg}))
   (su/multi-ref-field :lp-promotion/target-funds
                       "Target funds"
                       nil
                       (system-controlled {:authorization su/access-system-lpg}))
   (su/multi-ref-field :lp-promotion/priority-funds
                       "Priority funds"
                       nil
                       (system-controlled {:authorization su/access-system-lpg}))))
